<template>
    <section
        v-if="trendingGames.length"
        :class="$style.section"
        :data-interface-section="trendingCategory.id"
    >
        <ShelfTitle
            :title="trendingCategory.title"
            :link="trendingCategory.location"
            categoryId="trending_now"
        />
        <GeneralShelf
            :games="trendingGames.slice(0, 9)"
            :link="trendingCategory.location"
            :gameLinkTarget="undefined"
            :ctrContext="trendingCtrContext"
            embedded
            :categoryName="trendingCategory.title"
        />
    </section>
</template>
<script lang="ts" setup>
import { onServerPrefetch } from 'vue'

import GeneralShelf from '@/components/GamesShelf/GeneralShelf.vue'
import ShelfTitle from '@/components/GamesShelf/ShelfTitle.vue'
import { useCtrContext } from '@/composables/use-ctr-context'
import { useTrendingData } from '@/query/use-trending-data'

const {
    currentTrending: trendingCategory,
    unzippedTrendingWithGames: trendingGames,
    preloadTrendingData,
} = useTrendingData()

const trendingCtrContext = useCtrContext(() => ({ placement: 'trending_now', dimension1: 'notFoundPage' }))

onServerPrefetch(async () => {
    try {
        await preloadTrendingData()
    } catch (error) {
        console.error('Failed to preload trending data for 404 page:', error)
    }
})
</script>
<style module>
.section {
    margin-top: 40px;
    margin-bottom: 24px;
}
</style>
